import {Col, Row, Button, Form} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import ParticipantForm from "../form/participantForm";
import {useLocation, useNavigate} from "react-router-dom";
import ApiService from "../../services/ApiService";
import LogoutButton from "../layout/logoutButton";
import GenericErrorModal from "../modal/genericErrorModal";
import DateTimeUtils from "../../services/DateTimeUtils";

const Participant = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [nomeCognome, setNomeCognome] = useState("");
    const [dataDiNascita, setDataDiNascita] = useState();
    const [livelloRaggiunto, setLivelloRaggiunto] = useState("");
    const [showParticipantRegistrationAlert, setShowParticipantRegistrationAlert] = useState(false)
    const [participantAlertContent, setParticipantAlertContent] = useState({})


    useEffect(() => {
        ApiService.getParticipantById(location.state?.participantId).then(partData => {
            setNomeCognome(partData.firstName + " " + partData.lastName)
            setDataDiNascita(DateTimeUtils.getEmissionDateFromExpiring(partData.dob))
            setLivelloRaggiunto(partData.currentLevel)
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const handleSalvaAndChiudi = (event) => {
        event.preventDefault();

        let partNomeCognome = nomeCognome.split(" ");
        let participantParameter = {
            firstName: partNomeCognome[0],
            lastName: partNomeCognome[1],
            dob: dataDiNascita + " 00:00",
            currentLevel: livelloRaggiunto
        }

        if (location.state?.editMode) {
            ApiService.editParticipantInfo(participantParameter, location.state?.participantId).then(response => {
                setParticipantAlertContent({
                    title: "Modifica Partecipante",
                    body: "Modifica avvenuta con successo."
                })
                setParticipantAlertContent(true)
                navigate(-1)
            })
        } else {
            ApiService.createPartecipant(participantParameter)
                .then(partJson => {
                    setParticipantAlertContent({
                        title: "Creazione Partecipante",
                        body: "Creazione avvenuta con successo."
                    })
                    setParticipantAlertContent(true)
                    navigate(-1)
                })
                .catch(errorResponse => {
                    if (errorResponse.status === 409) {
                        setParticipantAlertContent({
                            title: "Errore Creazione Partecipante",
                            body: "Il partecipante risulta essere già registrato"
                        })
                        setParticipantAlertContent(true)
                    }
                })
        }
    }

    const handleCloseParticipantAlert = () => setShowParticipantRegistrationAlert(false);

    return (
        <>
            <Row>
                <Col lg={6}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Partecipante</h2>
                        </Col>
                    </Row>

                    <Row className={'my-4'}>
                        <Col xs={12}>
                            <Form>
                                <ParticipantForm setNomeCognome={setNomeCognome} nomeCognome={nomeCognome} setDataDiNascita={setDataDiNascita} dataDiNascita={dataDiNascita}
                                                 setLivelloNuoto={setLivelloRaggiunto} livelloNuoto={livelloRaggiunto}/>

                                <div className={'d-flex flex-column justify-content-end align-items-end'}>
                                    <Button variant={'primary'} className={'px-4 fw-bold'}
                                            onClick={(e) => handleSalvaAndChiudi(e)}
                                            disabled={(nomeCognome === "" || dataDiNascita === undefined || livelloRaggiunto === "")}>
                                        Salva e chiudi</Button>
                                    <Button variant={'link'} onClick={() => navigate(-1)} className={'p-0 mt-2'}>Annulla modifiche</Button>
                                    <Button variant={'link'} className={'p-0 mt-2'}>Elimina</Button>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </Col>

                <GenericErrorModal contentText={participantAlertContent} showModal={showParticipantRegistrationAlert}
                                   handleClose={handleCloseParticipantAlert}/>

                <Col>
                    <div className={'w-100 mt-4 mt-lg-0 d-flex justify-content-end'}>
                        <LogoutButton/>
                    </div>
                </Col>
            </Row>

        </>

    );
}

export default Participant;
